<template>
  <div class="modal-wrap">
    <el-dialog
      :title="formData.appName || '-'"
      :visible.sync="dialogVisible"
      width="428px"
    >
      <div class="form-wrap">
        <div class="cols-row">
          <span class="col-label">包名/ID：</span>
          <span class="col-value">{{ formData.afid }}</span>
        </div>
        <div class="cols-row">
          <span class="col-label">产品负责人：</span>
          <span class="col-value">{{ formData.productPrincipalUser }}</span>
        </div>
        <div class="cols-row">
          <span class="col-label">项目组：</span>
          <span class="col-value">{{ formData.productGroupName }}</span>
        </div>
        <div class="cols-row">
          <span class="col-label">分组：</span>
          <span class="col-value">{{ formData.groupName }}</span>
        </div>
        <div class="cols-row">
          <span class="col-label">竞品：</span>
          <span class="col-value">
            <el-input
              :disabled="readOnly"
              v-model="formData.competitiveProduct"
              placeholder="请输入内容"
            ></el-input>
          </span>
        </div>
      </div>
      <div class="update-wrap">
        <div class="modal-title">产品更新记录</div>
        <div class="log-area">{{ formData.updateContent }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          :loading="loading"
          @click="savePro"
          type="primary"
          v-if="!readOnly"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { modCompetitiveProduct } from "@/api/popuManage.js";
export default {
  name: "TimeModal",
  props: {
    readOnly: Boolean,
  },
  data() {
    return {
      dialogVisible: false,
      curId: null,
      formData: {
        afid: "-",
        productPrincipalUser: "-",
        productGroupName: "-",
        groupName: "-",
        competitiveProduct: "-",
        updateContent: "-",
        appName: "-",
      },
      loading: false,
    };
  },
  methods: {
    showDetailModal(row) {
      this.curId = row.productId;
      this.formData.afid = row.afid;
      this.formData.productPrincipalUser = row.productPrincipalUser;
      this.formData.productGroupName = row.productGroupName;
      this.formData.groupName = row.groupName;
      this.formData.competitiveProduct = row.competitiveProduct;
      this.formData.updateContent = row.updateContent;
      this.formData.appName = row.appName;
      this.dialogVisible = true;
    },
    savePro() {
      this.loading = true;
      modCompetitiveProduct({
        id: this.curId,
        competitiveProduct: this.formData.competitiveProduct,
      }).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.$message({
            message: "竞品修改成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.$emit("refresh", false);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  .form-wrap {
    .cols-row {
      font-size: 14px;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      .col-label {
        text-align: right;
        display: inline-block;
        width: 90px;
        color: rgba(0, 0, 0, 0.65);
        flex-shrink: 0;
      }
      .col-value {
        width: 100%;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
  .update-wrap {
    padding-top: 12px;
    .modal-title {
      color: rgba(0, 0, 0, 0.65);
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 12px;
      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 12px;
        border-radius: 2px;
        background: rgba(24, 144, 255, 1);
        margin-right: 4px;
        position: relative;
        top: 1px;
      }
    }
    .log-area {
      padding: 16px;
      box-sizing: border-box;
      border-radius: 2px;
      background: rgba(244, 244, 244, 1);
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
    }
  }
}
</style>